var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingPageBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 975,
    height: 786,
    viewBox: "0 0 975 786",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M835.624 15.1242C781.194 -55.408 755.53 -124.321 749.501 -149.961L27.7636 -31.6872L174.543 864L449.123 819.004C373.057 588.94 565.116 438.001 728.83 359.356C892.544 280.711 903.662 103.289 835.624 15.1242Z",
    fill: "url(#paint0_linear_91_2373)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M695.476 -95.2965C681.811 -154.185 671.621 -239.23 667.409 -276.746L127.569 -238.19L312.473 769.558L383.058 764.517C368.759 729.867 345.474 617.219 366.723 443.834C393.285 227.102 544.982 234.888 654.307 183.63C763.631 132.372 712.557 -21.6863 695.476 -95.2965Z",
    fill: "url(#paint1_linear_91_2373)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M425.966 -138.414C422.764 176.616 140.654 237.64 -4.00095e-05 228.773L287.142 -226.056L425.966 -138.414Z",
    fill: "url(#paint2_linear_91_2373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_2373",
    x1: 1580.06,
    y1: -91.155,
    x2: 377.175,
    y2: 101.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_91_2373",
    x1: 1721.76,
    y1: -450.933,
    x2: 0.822678,
    y2: 24.2076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_91_2373",
    x1: 1440.4,
    y1: -346.817,
    x2: 116.198,
    y2: -385.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageBg);
export default __webpack_public_path__ + "static/media/LandingPageBg.7ed3d79d5413896fa7cd21671cf85aa5.svg";
export { ForwardRef as ReactComponent };